import Form from 'react-bootstrap/Form';
import React, { useState, useEffect, useRef } from "react"
import {useNavigate} from 'react-router-dom';
import Overlay from "react-overlay-component";
import { Link } from "react-router-dom";
import { Vertify } from '@alex_xu/react-slider-vertify';
import PanelDisplayImage from '../../components/panel/PanelDisplayImage.js';
import PanelInputMobile from '../../components/panel/PanelInputMobile.js';
import PanelSelectShop from '../../components/panel/PanelSelectShop.js';
import PanelCheckboxTnc from '../../components/panel/PanelCheckboxTnc.js';
import PanelSelectProductQty from '../../components/panel/multi-pickup/PanelSelectProductQtyMulti.js';
import FailTitleDiv from '../../components/shared/TitleDiv.js';
import LongButton from '../../components/shared/LongButton.js';
import '../../css/EnrollM1.css';

function EnrollMultiStep2(props) {
    const navigate = useNavigate();
    const PUBLIC_URL =process.env.PUBLIC_URL;
    const url = new URL(window.location.href);
    let baseUrl = `${url.protocol}//${url.host}/`;

    const PistachioEventNames = process.env.REACT_APP_PISTACHIO_EVENT_NAME.split(',');

    if (process.env.REACT_APP_API_URL != ""){
      baseUrl = process.env.REACT_APP_API_URL;
    }
    const eventName = window.name;

    const isPistachioEvent = PistachioEventNames.includes(eventName);

    const bgColor = process.env.REACT_APP_BG_COLOR;
    const imgStep1 = process.env.REACT_APP_URL_IMAGE + "step-01.png";
    var clearChildItemsState = null;
    let tracking_channel = "others";

    if (props.channel !== ""){
      tracking_channel = props.channel;
    }
    if (props.geocode == "" || props.mobile == ""){
        navigate('../' + PUBLIC_URL + '/' + eventName + '/enroll');
    }
    
    const [settings, setSettings] = useState({
      Event_Status: "",
      Is_Maintenance: false,
      Event_Picture: "",
      Event_Button_Wording: "",
      Event_PreOrder_Method: "",
      Event_PreOrder_TnC: "",
      AllButton_Color: "",
      AllButton_FontColor: "",
      AllTitle_Color: "#FFFFFF",
      AllTitle_FontColor: "#FFFFFF",
      AllBackground_Color : "#FFFFFF"
    });  
    
    const [isSubmitting, setSubmitting] = useState(false);
    const [rules, setRules] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [orgItem_Details, setOrgItem_Details]=useState([]);
    const [item_Details, setItem_Details]=useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totalAmount, setTotalAmount]=useState(0);
    const [isOpenVerify, setIsOpenVerify] = useState(false);
    const [puzzleUrl, setPuzzleUrl] = useState("");
    const [visible, setVisible] = useState(false);
    const [inputs, setInputs] = useState({
      event_code : "",
      batch_no : "",
      stamp : "",
      code : "",
      geocode : props.geocode,
      mobile : props.mobile,
      geocode2 : props.geocode,
      mobile2 : props.mobile,
      loc_code : "",
      channel : tracking_channel,
      tracking_channel : tracking_channel,
      cbxTncs:[]
    });
      const style = {
        margin: '50px'
      };
    useEffect(() => {
        let GetEventStatusURL = baseUrl + "frontend/api/Enroll/GetEventStatus";
        fetch(GetEventStatusURL, {
          "method": "POST",
          "headers": {
            'Content-Type': 'application/json'
          },
          "body": JSON.stringify({
            "event_Name": eventName
          })
        })
        .then(response => response.json())
        .then(response => { 
          let result = JSON.parse(JSON.stringify(response));
          if(props.isdebugmode) console.log(result);
          setSettings(previousState => {
            return { 
              ...previousState,
              Event_Status : result.Event_Status,
              Is_Maintenance: result.Is_Maintenance,
              Event_Button_Wording : result.Event_Button_Wording,
              Event_Picture : result.Event_Picture,
              Event_PreOrder_Method : result.Event_PreOrder_Method,
              Event_PreOrder_TnC : result.Event_PreOrder_TnC,
              AllButton_Color : result.AllButton_Color,
              AllButton_FontColor : result.AllButton_FontColor,
              AllTitle_Color : result.AllTitle_Color,
              AllTitle_FontColor : result.AllTitle_FontColor,
              AllBackground_Color : result.AllBackground_Color
            }
          });
          //console.log("Event_Status" + result.Event_Status);
          if (result.Event_Status !== "Processing" && result.Event_Status !== "Testing"){
            navigate('../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }
        })
        .catch(err => { if(props.isdebugmode) console.log(err); });

        
        let GetEventInfoEnrollURL = baseUrl + "frontend/api/Enroll/GetEventInfoEnroll";
        fetch(GetEventInfoEnrollURL, {
          "method": "POST",
          "headers": {
            'Content-Type': 'application/json'
          },
          "body": JSON.stringify({
            "event_Name": eventName
          })
        })
        .then(response => response.json())
        .then(response => { 
          let result = JSON.parse(JSON.stringify(response));
          if(props.isdebugmode) console.log(result);
          ToDataUrl(result.Image_Setting.Puzzle_Picture, function(myBase64) {
            setPuzzleUrl(myBase64); // myBase64 is the base64 string
            setVisible(true);
          });

          setRules(result.EnrollM1_TnC);
          let newcbxTncs=Array();
          for (var i=0;i<result.EnrollM1_TnC.length;i++)
          {
            newcbxTncs.push({TnC_id:result.EnrollM1_TnC[i].TnC_id,
                             checked: result.EnrollM1_TnC[i].IsDefault});
          }
          setInputs(oldValues => ({...oldValues, cbxTncs: newcbxTncs }));
          let newDistricts= [
            {Loc_Id:'0', Loc_Name: '請選擇',constDisplay_Loc_Id:'',Display_Loc_Name: '',District:'',IsShown:true}]; 
          newDistricts = newDistricts.concat(result.Location_Detail);
          let isRegDateExist=false;
          for (var i=0;i<result.Event_Reg_Period.length;i++)
          {
            let Effective_Date = new Date(result.Event_Reg_Period[i].Effective_Date);
            let DateNow= new Date();
            if (Effective_Date.getFullYear() == DateNow.getFullYear() && Effective_Date.getMonth() == DateNow.getMonth() && Effective_Date.getDate() == DateNow.getDate())
            {
              var Batch_No=result.Event_Reg_Period[i].Batch_No;
              setInputs(oldValues => ({...oldValues, batch_no: Batch_No }));
              isRegDateExist=true;
            }
          }
          //console.log("isRegDateExist:" + isRegDateExist);
          if (isRegDateExist)
          {
            setDistricts(newDistricts);
            //setOrgItem_Details(result.Item_Detail);
            // setOrgItem_Details([
            //     {
            //         "Order_Id": "1",
            //         "Item_Code": "88142139",
            //         "Item_Name": "樓上龍年開心果",
            //         "Item_Spec": "(1磅/袋)",
            //         "Item_Unit": "袋",
            //         "Item_RetailPrice": 68,
            //         "Item_ActualPrice": 33,
            //         "Item_RetailPrice_MO": 70,
            //         "Item_ActualPrice_MO": 34,
            //         "Item_Min_Qty": 1,
            //         "Item_Max_Qty": 6,
            //         "Item_POS_Promo_ID": "2023-277"
            //     },
            //     {
            //         "Order_Id": "2",
            //         "Item_Code": "88142140",
            //         "Item_Name": "樓上龍年開心果2",
            //         "Item_Spec": "(1磅/袋)",
            //         "Item_Unit": "袋",
            //         "Item_RetailPrice": 68,
            //         "Item_ActualPrice": 33,
            //         "Item_RetailPrice_MO": 70,
            //         "Item_ActualPrice_MO": 34,
            //         "Item_Min_Qty": 1,
            //         "Item_Max_Qty": 6,
            //         "Item_POS_Promo_ID": "2023-278"
            //     },
            //     {
            //         "Order_Id": "3",
            //         "Item_Code": "88142141",
            //         "Item_Name": "樓上龍年開心果3",
            //         "Item_Spec": "(1磅/袋)",
            //         "Item_Unit": "袋",
            //         "Item_RetailPrice": 68,
            //         "Item_ActualPrice": 33,
            //         "Item_RetailPrice_MO": 70,
            //         "Item_ActualPrice_MO": 34,
            //         "Item_Min_Qty": 1,
            //         "Item_Max_Qty": 6,
            //         "Item_POS_Promo_ID": "2023-279"
            //     }
            //     ]);
          }
        })
        .catch(err => { if(props.isdebugmode) console.log(err); });        
        
        let GetMultiPickupProd = baseUrl + "frontend/api/Enroll/GetMultiPickupProduct";
        fetch(GetMultiPickupProd, {
          "method": "POST",
          "headers": {
            'Content-Type': 'application/json'
          },
          "body": JSON.stringify({
            "Event_Name": eventName
          })
        })
        .then(response => response.json())
        .then(response => { 
          let result = JSON.parse(JSON.stringify(response));
          if(props.isdebugmode) console.log(result);
          setOrgItem_Details(result.Item_Detail);
        })
        .catch(err => { if(props.isdebugmode) console.log("GetMultiPickupProduct" + err); });

        window.QueueIt && window.QueueIt.validateUser();
      }, []);
      
  const locationChange = (e) => {
    setTotalAmount(0);
    setInputs(oldValues => ({...oldValues, loc_code: e.target.value }));
    setItem_Details([]);
    let url = baseUrl + "frontend/api/Enroll/GetAvailableItemByLocation_v2";

    if (e.target.value !== "0" )
      {
        setIsLoading(true);
      }

      fetch(url, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "event_Name": eventName,
          "loc_Id": e.target.value,
          "Geocode":inputs.geocode,
          "Mobile":inputs.mobile,
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));

        if(props.isdebugmode) console.log(result);
        //console.log(result);
        //let newItem_Details = [...orgItem_Details]; 
        let newItem_Details = []; 
        let isHK = true;
        if(e.target.value.substring(0, 2) == "21"){
            isHK = false;
        }
            
        // for (var j=0;j<orgItem_Details.length;j++)
        // {
        //     newItem_Details.push(orgItem_Details[j]);
        //     newItem_Details[newItem_Details.length-1].SubTotal = 0;
        //     newItem_Details[newItem_Details.length-1].Available_PickupDate_From=result.Items[0].Available_PickupDate_From;
        //     newItem_Details[newItem_Details.length-1].Available_PickupDate_To=result.Items[0].Available_PickupDate_To;
        //     newItem_Details[newItem_Details.length-1].Is_Available=result.Items[0].Is_Available;
        // }
        

        for (var i=0;i<result.Items.length;i++)
        {
          if(props.isdebugmode) console.log("i am i:" + result.Items[i].Item_Code);
          for (var j=0;j<orgItem_Details.length;j++)
          {
            if(props.isdebugmode) console.log("i am j:" + orgItem_Details[j].Item_Code);
            if (result.Items[i].Item_Code == orgItem_Details[j].Item_Code) 
            {
              if(props.isdebugmode) console.log("i am j if:");
              //console.log(result.Items[i].Is_Available);
              //console.log(result.Items[i].Pickup_Group);
              //console.log(result.Items[i].Pickup_Order);

              if(isHK && result.Items[i].Pool_Header == "HK"){
                    newItem_Details.push(orgItem_Details[j]);
                    newItem_Details[newItem_Details.length-1].SubTotal = 0;
                    newItem_Details[newItem_Details.length-1].Available_PickupDate_From=result.Items[i].Available_PickupDate_From;
                    newItem_Details[newItem_Details.length-1].Available_PickupDate_To=result.Items[i].Available_PickupDate_To;
                    newItem_Details[newItem_Details.length-1].Is_Available=result.Items[i].Is_Available;
                    newItem_Details[newItem_Details.length-1].Is_Purchased=result.Items[i].Is_Purchased;
                    newItem_Details[newItem_Details.length-1].Pickup_Group=result.Items[i].Pickup_Group;       
                    newItem_Details[newItem_Details.length-1].Pickup_Order=result.Items[i].Pickup_Order;                    
              } 
              if(!isHK && result.Items[i].Pool_Header == "MO") {
                    newItem_Details.push(orgItem_Details[j]);
                    newItem_Details[newItem_Details.length-1].SubTotal = 0;
                    newItem_Details[newItem_Details.length-1].Available_PickupDate_From=result.Items[i].Available_PickupDate_From;
                    newItem_Details[newItem_Details.length-1].Available_PickupDate_To=result.Items[i].Available_PickupDate_To;
                    newItem_Details[newItem_Details.length-1].Is_Available=result.Items[i].Is_Available;
                    newItem_Details[newItem_Details.length-1].Is_Purchased=result.Items[i].Is_Purchased;
                    newItem_Details[newItem_Details.length-1].Pickup_Group=result.Items[i].Pickup_Group;
                    newItem_Details[newItem_Details.length-1].Pickup_Order=result.Items[i].Pickup_Order;
              }
            }
          }
        }
        setItem_Details(newItem_Details);
      })
      .catch(err => { console.log(err); })
      .finally(() => {
        setIsLoading(false);
      });

      clearChildItemsState();
  }

  const setItemQty = (Item_Code, value) => {
    let newItem_Details = [...item_Details]; 
    var total=0;
      for (var j=0;j<newItem_Details.length;j++)
      {
        if (Item_Code == newItem_Details[j].Item_Code) 
        {
          newItem_Details[j].SelectedQty=value;
          newItem_Details[j].SubTotal=value*newItem_Details[j].Item_ActualPrice;
        }
        total+=newItem_Details[j].SubTotal;
      }
      setTotalAmount(total);
    setItem_Details(newItem_Details);
  }

  const submitButtonOnClick = (e) => {
    if (isSubmitting) return;
    //console.log(item_Details);
    if (inputs.geocode == "" || inputs.geocode2 == "")
    {
      alert("請選擇區號。");
    }
    else if (inputs.mobile == "" || inputs.mobile2 == "")
    {
      alert("請輸入手提電話號碼。");
    }
    else if (inputs.geocode != inputs.geocode2 || inputs.mobile != inputs.mobile2)
    {
      alert("所輸入的手提電話號碼不相符。請重新輸入。");
    }
    else if (inputs.loc_code == "" || inputs.loc_code == 0)
    {
      alert("請選擇分店。");
    }
    else if (totalAmount == 0)
    {
      alert("請選擇產品。");
    }
    else
    {
      var isSuccess = true;
      
      for (var i=0;i<item_Details.length;i++)
      {        
        //if (item_Details[i].Item_Min_Qty != 0 && item_Details[i].SubTotal == 0)
        //{
        //  isSuccess=false;
        //  alert(item_Details[i].Item_Name + "必須選購。");
        //}


        if (item_Details[i].SelectedQty > item_Details[i].Item_Max_Qty)
        {
          isSuccess=false;
          alert(item_Details[i].Item_Name + "數量異常。");
        }
      }

      // Check exceed 6
      let groupMsg = '';
      const exceedQty = 99999;
      const groupQty = {};
      for (let i = 0; i < item_Details.length; i++) {
        const item = item_Details[i];
        const group = item.Pickup_Group;

        if (!groupQty[group]) {
          groupQty[group] = 0;
        }

        groupQty[group] += parseInt(item.SelectedQty) || 0;

        if (groupQty[group] > exceedQty) {
          isSuccess=false;
          groupMsg += `${group} 購買數量不能多過 ${exceedQty}包! \r\n` ;
        }
      }

      if (groupMsg != ''){
        alert(groupMsg);
        return false;
      }

      //cbxTnc
      for (var i=0;i<inputs.cbxTncs.length;i++)
      {
        if (!inputs.cbxTncs[i].checked)
        {
          isSuccess=false;
          alert("請同意所有條款。");
          return false;
        }
      }
      if (isSuccess)
      {
        // setIsOpenVerify(true);
        setSubmitting(true)
        VertifyonSuccess()
      }
    }
  }

  const VertifyonSuccess = (e) => {
    var Base_url = window.location.protocol + "//" + window.location.host+process.env.PUBLIC_URL+"/"+window.name+"/PaymentResult";
    let url = baseUrl + "frontend/api/Enroll/InsertEventRegistration_v2";
    let postData ={
      "Event_Name" : eventName,
      "Geocode": inputs.geocode,
      "Mobile": inputs.mobile,
      "Loc_Code": inputs.loc_code,
      "Loc_Name" : "",
      "Total_Amount_Mo_Str" : "",
      "Order_Item": {
          "Item_Detail":[
             ]
      },
      "Channel": inputs.channel,
      "Tracking_Channel": inputs.tracking_channel,
      "batch_No": inputs.batch_no,
      "Base_url": Base_url,
      "Is_allow_online_payment": true,
      "Is_allow_offline_payment": false,
      "CreatedBy": "Web"
    };
    for (var i=0;i<item_Details.length;i++)
    {
      
      if (item_Details[i].SelectedQty > 0 && item_Details[i].SubTotal > 0)
      {
        let items={"Item_Code": item_Details[i].Item_Code,"Item_Qty": item_Details[i].SelectedQty,"Item_ActualPrice": item_Details[i].Item_ActualPrice,"Item_TotalPrice": item_Details[i].SubTotal}
        postData.Order_Item.Item_Detail.push(items);
      }
    }
    
    fetch(url, {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json'
      },
      "body": JSON.stringify(postData)
    })
    .then(response => response.json())
    .then(response => { 
      let result = JSON.parse(JSON.stringify(response));
      //alert(JSON.stringify(response));  
      //console.log(JSON.stringify(response));
      if(props.isdebugmode) console.log(JSON.stringify(response));

    //   if (result.hasOwnProperty('IsSuccess')){
    //     alert(result.IsSuccess);
    //   }
      
        //console.log(result.IsSuccess);
      if (result.IsSuccess === false){
        if(props.isdebugmode) alert(result.ErrorMessage);
        if (result.ErrorCode === 10012){
          navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-duplicate');
        } else if (result.ErrorCode === 10514){
          navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-wrong-format');
        } else if (result.ErrorCode === 10518 || result.ErrorCode === 10005 || result.ErrorCode === 10007){
          navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-full-quota');
        } else {
          navigate('../' + PUBLIC_URL + '/' + eventName + '/fail-reg-error?errcode=' + result.ErrorCode);
        }        
      } else {
        //let invoiceno = result.RegRecord[0].Invoice_Number;
        //let url = result.RegRecord[0].invoice_url;
        //url = url.replace(invoiceno , invoiceno.substring(0, invoiceno.length-2));
        //alert(result.RegRecord[0].invoice_url);
        //window.location = url;
        window.location = result.RegRecord[0].invoice_url;
      }        
    })
    .catch(err => { console.log(err); setSubmitting(false); });
    
    setIsOpenVerify(false);
  }
  const VertifyonFail = (e) => {

  }
  const VertifyonRefresh = (e) => {

  }
  const checkboxOnChange = (e) => {
    var newcbxTncs=[...inputs.cbxTncs];
    for (var i=0;i<newcbxTncs.length;i++)
    {
      if (("cbxTnc"+newcbxTncs[i].TnC_id) == e.target.name)
      {
        newcbxTncs[i].checked = e.target.checked;
        setInputs(oldValues => ({...oldValues, cbxTncs: newcbxTncs }));
        break;
      }
    }
  }
  const ClearSelectedItems = (childClearSelectedItems) => {
    clearChildItemsState = childClearSelectedItems;
  }

  return (
    <>
        {/* <Overlay configs={{animate: true}} isOpen={isOpenVerify} closeOverlay={()=>setIsOpenVerify(false)}>
        <p></p>
        <Vertify
            className={style}
            imgUrl={puzzleUrl}
            text="向右拉箭咀以完成上方拼圖"
            width={320}
            height={180}
            visible={visible}
            onSuccess={() => VertifyonSuccess()}
            onFail={() => VertifyonFail()}
            onRefresh={() => VertifyonRefresh()}
        />
        </Overlay> */}
        <Form>
        {
            (isLoading) &&  
            <div className="d-flex flex-column Location_Loader">  
              <div class="row">
                  <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                  </div>
              </div>
              <br/>
              <div class="row">
                {isLoading && <strong>加載中，請耐心等待</strong>}
              </div>
            </div>
          }

                <FailTitleDiv class="title" title="產品預購" bgColor={settings.AllTitle_Color} fontColor={settings.AllTitle_FontColor}></FailTitleDiv>
                <div className="d-grid" style={{backgroundColor: settings.AllBackground_Color}}>
                    <PanelDisplayImage imagesrc={imgStep1}></PanelDisplayImage>
                    <PanelSelectShop districtsList={districts} onChange={locationChange}></PanelSelectShop>
                    <PanelSelectProductQty passClearSelectedItems={ClearSelectedItems} item_Details={item_Details} totalAmount={totalAmount} setItemQty={(Item_Code, value) =>setItemQty(Item_Code, value)} isShowScanInput={false} isPistachioEvent={isPistachioEvent} ></PanelSelectProductQty>
                    <PanelCheckboxTnc tncList={rules} checkboxOnChange={checkboxOnChange}></PanelCheckboxTnc>
                    {
                      settings.AllButton_Color !== '' && <LongButton isDisabled={isSubmitting} class="enroll-button" text="確認訂單" bgColor={settings.AllButton_Color} fontColor={settings.AllButton_FontColor}  onClick={() => { submitButtonOnClick(); }} ></LongButton>
                    }
                </div>
        </Form>
    </>
  );
}

function ToDataUrl(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
          callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.setRequestHeader("Cache-Control", "no-cache");
  xhr.responseType = 'blob';
  xhr.send();
}

export default EnrollMultiStep2;
